import { render, staticRenderFns } from "./InquiryPage.vue?vue&type=template&id=35c2b654&scoped=true&lang=pug&"
import script from "./InquiryPage.vue?vue&type=script&lang=ts&"
export * from "./InquiryPage.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryPage.vue?vue&type=style&index=0&id=35c2b654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c2b654",
  null
  
)

export default component.exports